<template minapp='mpx' xlang='wxml'>
  <es-layout
    leftArrow="{{true}}"
    navbarTitle="本人行程"
    custom-class="custom-class"
    bindscrolltobottom="onScrollToBottom"
    navbarClickLeft="{{goBack}}"
    navbarStyle="{{navbarStyle}}"
  >
    <!-- 无订单 -->
    <view class="order-tip" wx:if="{{isShowEmpty}}">
      <image
        class="null-image"
        src="https://pt-starimg.didistatic.com/static/starimg/img/8jPyrnQfol1642402065727.png"
      />
      <view class="null-title">暂无火车票行程</view>
      <view class="null-context">当前暂无火车票行程记录</view>
    </view>
    <view class="order-list" wx:else>
      <view
        class="item"
        wx:for="{{tickets12306List}}"
        bindtap="goDetail(index)"
      >
        <newTrainOrderCard item="{{item}}" tickets12306="{{true}}" />
      </view>
      <!-- 加载状态 -->
		  <view class="order-loading">{{ loadingText }}</view>
    </view>
  </es-layout>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { get12306Tickets } from '@/api/tickets12306'
  import store from '@/store'
  import { innerRouter, pagePath } from '@/common/jump'

  createPage({
    data: {
      loadingIcon: 'https://pt-starimg.didistatic.com/static/starimg/img/r2q8WK5PAH1652165229145.png',
      loadingStatus: false, // 加载状态
      loadingText: '',
      page: 1
    },
    mounted() {
      this.page = 1
    },
    computed: {
      ...store.mapState({
        tickets12306List: 'tickets12306.tickets12306List',
        totalPage: 'tickets12306.totalPage'
      }),
      isShowEmpty() {
        return !(this.tickets12306List?.length > 1)
      },
      navbarStyle() {
        return { background: '#fff' }
      },
    },
    methods: {
      ...store.mapActions({
        get12306TicketsAction: 'tickets12306.get12306TicketsAction',
      }),
      goBack() {
        innerRouter.replace(pagePath().ORDERLIST)
      },
      goDetail(index) {
        innerRouter.push(pagePath().TICKETS12306DETAIL, { index })
      },
      async onScrollToBottom() {
        if(!this.loadingStatus) {
          this.loadingStatus = true
          if(this.page == this.totalPage) {
            this.loadingText = '没有更多数据了'
            return 
          } else {
            this.loadingText = '数据加载中...'
            this.page++
            await this.get12306TicketsAction({pageIndex: this.page})
          }
          this.loadingStatus = false
        }
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .custom-class
    height 100%
  .order-tip
    text-align center
    font-weight 400
    height 100%
    background #F3F4F5
  .null-image
    height 100px
    width 100px
    margin-top 172px
  .null-title
    color #333
    font-size 14px
    margin 16px 0 2px 0
    height 20px
    ling-height 20px
  .null-context
    color #999
    font-size 12px
  .order-list
    padding 2px 10px
  .item
    margin-top 8px
  .order-loading
    height 40px
    width 100%
    text-align center
    line-height 40px
    font-size 14px
    color #666
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      newTrainOrderCard: '../order-list/components/newTrainOrderCard.mpx'
    }
  }
</script>
